<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" :offset="20">
                    <el-button type="primary" @click="add()" size="mini" class="header-btn">新建</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="id" prop="id"></el-table-column>
            <el-table-column label="标签名称" prop="name"></el-table-column>
            <el-table-column label="标签状态" prop="status">
                <template slot-scope="scope">
                    <span>{{scope.row.status==1?'已启用':'未启用'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="模板名称" prop="name"></el-table-column>
            <el-table-column prop="createDate" label="创建时间">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.createTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="标签单位" prop="unit"></el-table-column>
            <el-table-column label="标签备注" prop="remark"></el-table-column>
            <el-table-column label="标签表" prop="source"></el-table-column>
            <el-table-column label="过滤字段" prop="filterField"></el-table-column>
            <el-table-column label="模板sql" prop="tempSql"></el-table-column>
            <el-table-column label="标签分类" prop="tagClassName"></el-table-column>

            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="edit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>

                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="Tag设置" :visible.sync="showDialog">
            <el-form :model="model" label-width="120px">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="model.name" placeholder="名称"></el-input>
                    <span style="color: red">*名称必填</span>
                </el-form-item>
                <el-form-item label="标签表" prop="source">
                    <el-input v-model="model.source"  placeholder="标签表"></el-input>
                    <span style="color: red">*对应BI库中取数据的表名</span>
                </el-form-item>
                <el-form-item label="模板sql" prop="type">
                    <el-input v-model="model.tempSql" placeholder="单位"></el-input>
                    <span style="color: red">*模板sql</span>
                </el-form-item>
                <el-form-item label="过滤字段" prop="type">
                    <el-input v-model="model.filterField" placeholder="过滤字段"></el-input>
                    <span style="color: red">*过滤字段 tag 对应BI系统中表筛选过滤的字段</span>
                </el-form-item>
                <el-form-item label="过滤字段类型" prop="type">
                    <el-select v-model="model.type"  placeholder="过滤字段类型">
                        <el-option v-for="item in filderTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="tag分类" prop="type">
                    <el-select v-model="model.tagClass"  placeholder="过滤字段类型">
                        <el-option v-for="item in tagClassList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">*tag分类 </span>
                </el-form-item>
                <el-form-item label="单位" prop="type">
                    <el-input v-model="model.unit" placeholder="单位"></el-input>
                    <span style="color: red">过滤字段中的单位,日期类型请填写天</span>
                </el-form-item>
                <el-form-item label="说明" prop="remark">
                    <el-input v-model="model.remark"  placeholder="remark"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="save()" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getTagListApi, deleteTagApi, saveTagApi
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: false,
                formInline: {
                    currentPage: 1,
                    pageSize: 20,
                    pid: 0,
                    name: "",
                },
                list: [],
                filderTypeList:[{id:1,name:'文本'},{id:2,name:'日期'},{id:3,name:'整形'},{id:4,name:'金额'},{id:5,name:'选项'},{id:6,name:'是否'}],//过滤字段类型
                tagClassList:[{id:1,name:'用户行为'},{id:2,name:'交易'},{id:3,name:'营销'},{id:4,name:'用户属性'}],
                model: {
                    name: '',
                    type:1,
                    pid:0,
                    status:1,
                    unit: '',
                    remark: '',
                    hasLeaf: 0,
                    source: '',
                    filterField:'',
                    tempSql:'',
                    tagClass:1
                },
                loading: true,
                recordsTotal: 0,
                rules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getList();
        },
        methods: {
            getList(){
                //查询模板列表
                getTagListApi(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.list = res.data.value;
                        this.recordsTotal =this.list.length;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            add(){
                this.model = {
                    name: '',
                    type:1,
                    pid:0,
                    status:1,
                    unit: '',
                    remark: '',
                    hasLeaf: 0,
                    source: '',
                    filterField:'',
                    tempSql:'',
                    tagClass:1
                };
                this.showDialog = true;
            },
            edit(row){
                this.model = {
                    id:row.id,
                    name: row.name,
                    type:row.type,
                    pid:row.pid,
                    status:row.status,
                    unit: row.unit,
                    remark: row.remark,
                    hasLeaf: row.hasleaf,
                    source: row.source,
                    filterField:row.filterField,
                    tempSql:row.tempSql,
                    tagClass:row.tagClass
                };
                this.showDialog = true;
            },
            save(){
                //名称判空
                if(this.model.name==''){
                    this.$message({
                        message: '名称不能为空',
                        type: 'error'
                    });
                    return;
                }
                if(this.model.filterField==''){
                    this.$message({
                        message: '过滤字段不能为空',
                        type: 'error'
                    });
                    return;
                }
                if(this.model.source==''){
                    this.$message({
                        message: '标签表不能为空',
                        type: 'error'
                    });
                    return;
                }
                if(this.model.tempSql==''){
                    this.$message({
                        message: '模板sql不能为空',
                        type: 'error'
                    });
                    return;
                }
                this.loading=true;
                //保存
                saveTagApi(this.model).then((res) => {
                    console.log(res);
                    this.loading=false;
                    if (res.data.success) {
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            handleDel(row){
                //删除
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteTagApi({tagId:row.id}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.showDialog = false;
                    });
                })
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/sms/tag.vue